var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]}},[_c('LoadingSvg',_vm._b({staticClass:"spin",attrs:{"original":true}},'LoadingSvg',_vm.dimensions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }